// TODO: Codegen from OpenAPI spec

export const CUSTOM_TEXT_BLOCK_TYPE = 'CUSTOM_TEXT'

export const COMMENTS_BLOCK_TYPE = 'COMMENTS'

export const CUSTOM_CHART_BLOCK_TYPE = 'CUSTOM_CHART'

export const CustomReportBlockTypeEnum = {
  [CUSTOM_TEXT_BLOCK_TYPE]: CUSTOM_TEXT_BLOCK_TYPE,
  [COMMENTS_BLOCK_TYPE]: COMMENTS_BLOCK_TYPE,
  [CUSTOM_CHART_BLOCK_TYPE]: CUSTOM_CHART_BLOCK_TYPE
}
